import { render, staticRenderFns } from "./CommonFormPage.vue?vue&type=template&id=42d49ffe&scoped=true&lang=pug&"
import script from "./CommonFormPage.vue?vue&type=script&lang=js&"
export * from "./CommonFormPage.vue?vue&type=script&lang=js&"
import style0 from "./CommonFormPage.vue?vue&type=style&index=0&id=42d49ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d49ffe",
  null
  
)

export default component.exports